<div class="app-button-multi-select" *ngIf="menuItems?.length">
  <div class="button-group p-buttonset">
    <button
      pButton
      class="p-button"
      [disabled]="disabled || selectedMenuItem?.disabled"
      (click)="onButtonClick($event)"
      [ngStyle]="{
        'min-width': minWidth,
        'padding-right': '15px',
        'justify-content': 'flex-start',
      }"
      [pTooltip]="tooltipContent"
      tooltipPosition="left">
      <i
        *ngIf="!isProcessing"
        [ngClass]="selectedMenuItem?.icon || 'fa-thin fa-floppy-disk'"
        class="button-icon"
        [font.size]="'14px'"></i>
      <app-loading-dots size="4px" style="padding-right: 5px; display: inline-block;" *ngIf="isProcessing"></app-loading-dots>
      <span
        class="button-text"
        [ngClass]="{
          'app-button-multi-select-disabled': disabled,
        }">
        {{
          (isProcessing && selectedMenuItem.labelProcessing) ||
            selectedMenuItem?.label ||
            'Select An Option'
        }}
        <!-- {{ selectedMenuItem?.label || 'Select An Option' }} -->
      </span>
    </button>
    <button
      pButton
      *ngIf="menuItems?.length > 1"
      [disabled]="disabledSelection"
      class="p-button dropdown-button"
      (click)="toggleMenu($event)">
      <i class="fa-regular fa-angle-down"></i>
    </button>
  </div>

  <div class="dropdown-menu" *ngIf="showMenu">
    <ng-container *ngFor="let item of menuItems">
      <div
        *ngIf="item.action !== selectedMenuItem?.action"
        class="menu-item"
        [ngClass]="{ disabled: item.disabled }"
        (click)="onMenuItemSelect(item)">
        <i
          [class]="item.icon || 'fa-thin fa-floppy-disk'"
          class="menu-icon text-link-color"></i>
        <p class="menu-label text-link-color">{{ item.label }}</p>
      </div>
    </ng-container>
  </div>
</div>
